import axios from 'axios';

export function getHolidays(year){
    if(year != undefined){
        year = '?year=' + year;
    }else{
        year = '';
    }
    return axios.get(`https://canada-holidays.ca/api/v1/provinces${year}`, {})
}